"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.SIGNUP_MUTATION = graphql_tag_1.default `
  mutation UserSignUpMutation($user: UserCreateInput!, $authProfileId: ID) {
    userSignUp(user: $user, authProfileId: $authProfileId) {
      id
    }
  }
`;
//# sourceMappingURL=mutations.js.map